import { Injectable } from '@angular/core';
import * as Amplitude from 'amplitude-js/amplitude';
import { environment } from 'environments/environment';

@Injectable()
export class AmplitudeService {
  private amplitude = Amplitude.getInstance();

  constructor() {
    this.amplitude.init(environment.AMPLITUDE_API_KEY);
  }

  logEvent(...event) {
    this.amplitude.logEvent(...event);
  }

  setUserProperties(userProperties) {
    this.amplitude.setUserProperties(userProperties);
  }

  setUserId(userId) {
    this.amplitude.setUserId(userId);
  }

  setUser(user) {
    this.setUserId(user.username);
    this.setUserProperties({
      account: user.domain,
      name: user.name,
      surname: user.surname,
      companyName: user.companyName,
      role: user.role
    });
  }
}
